import React, { useEffect, useState } from "react";
import { GetLocalStorageParsed } from "../../Utils/Utils";
import { oldApplicationData } from "../../services/api/user";
import { useLanguage } from "../LanguageProvider/LanguageProvider ";
import Dashboard from "../../pages/Dashboard/Dashboard";

const OldApplication = () => {
  const userDetail = GetLocalStorageParsed("userDetail");
  const { language } = useLanguage();
  const [appData, setAppData] = useState(null);

  useEffect(() => {
    fetchOldApplicationData();
  }, []);

  const fetchOldApplicationData = async () => {
    try {
      const formData = new FormData();
      formData.append("unique_id", userDetail?.unique_id);
      const details = await oldApplicationData(formData);
      if (details?.status === 200 && details?.data) {
        setAppData(details?.data); // Set the data
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  const formatApplicationData = (category) => {
    return category
      .split("_") 
      .map(
        (
          word
        ) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(" ");
  };

  return (
    <Dashboard
      first={language ? "होम" : "Home"}
      second={language ? "पुराना आवेदन" : "Old Application"}
      head={language ? "पुराना आवेदन" : "Old Application"}
    >
      {appData && appData.length > 0 ? (
        appData.map((item, index) => (
          <div className="mb-4">
            <div className="col-md-12">
              <div className="data-wrapper">
                <div key={index}>
                  <div className="data-wrapper-heading-block d-flex justify-content-between align-items-center">
                    <div className="data-wrapper-heading">
                      <h5 className="mb-0">
                        {language
                          ? appData.length === 1
                            ? "पुराना आवेदन"
                            : `पुराना आवेदन ${index + 1}`
                          : appData.length === 1
                          ? "Old Application"
                          : `Old Application ${index + 1}`}
                      </h5>
                    </div>
                  </div>
                  <div className="data-item-details">
                    <div className="row">
                      {Object.keys(item).map((key) => {
                        const fieldValue = item[key] || "--"; // Default to '--' if no value
                        return (
                          <div className="col-md-6" key={key}>
                            <div className="preview-data py-2 px-3 d-flex justify-content-between align-items-center">
                              <div className="preview-left-heading">
                                <h6 className="fw-bold mb-0">
                                  {formatApplicationData(key)}
                                </h6>
                              </div>
                              <div className="preview-right-heading w-75 text-end">
                                <p
                                  className="mb-0"
                                  dangerouslySetInnerHTML={{
                                    __html: fieldValue,
                                  }}
                                ></p>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="col-12">
        </div>
      )}
    </Dashboard>
  );
};

export default OldApplication;
